import React, { useEffect, useRef, useState } from "react";
import styles from "styles/BackgroundVideo.module.css";

const BackgroundVideo: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isLowPowerMode, setIsLowPowerMode] = useState(false);
  const [isVideoError, setIsVideoError] = useState(false);

  useEffect(() => {
    // 省電力モードを判定
    if ("connection" in navigator && (navigator as any).connection.saveData) {
      setIsLowPowerMode(true);
    } else {
      setIsLowPowerMode(false);
    }
  }, []);

  useEffect(() => {
    if (!isLowPowerMode && videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch((error) => {
        console.log("Autoplay failed, hiding video:", error);
        setIsVideoError(true); // エラー時に動画を非表示にする
      });
    }
  }, [isLowPowerMode]);

  return (
    <div
      className={styles["background-container"]}
      style={isLowPowerMode ? { backgroundColor: "#fdfdfd" } : {}}
    >
      {!isLowPowerMode && !isVideoError && ( // エラー発生時は動画を非表示
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          className={styles["background-video"]}
        >
          <source src="/movies/AREA_CUP.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default BackgroundVideo;
